import React, { useState } from "react"
import "semantic-ui-css/semantic.min.css"
import { Card, Container, Header, Image } from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { navigationPaths } from "../../constants/paths"
import Infologo from "../../assets/images/info.svg"
import { Link } from "react-router-dom"
import AddVehicleModal from "../shared/AddVehicle"

const UnenrolledVehicles = ({ vehicles, onAssign, count }) => {
  const { t } = useTranslation("dashboard")
  const [currentCard, setCurrentCard] = useState(null)

  return (
    <React.Fragment>
      <span />
      <Header size="small" className={"dash-hd"}>
        <div className="unassigned-cards-title">
          <span>{t("common:unassignedCards")} </span>
          {vehicles.length > 0 && (
            <div className="action-needed-title">
              <Image src={Infologo} />
              <span>{t("common:actionNeeded")}</span>
            </div>
          )}
        </div>
      </Header>
      <Card fluid>
        <Card.Content>
          <span>{t("theseCardsDoNotHaveVehicleAssignedAndCannotBeUsedForMaintenance")}</span>
        </Card.Content>
        <Card.Content
          className="px-5!"
          style={{ maxHeight: "280px", overflowY: "auto", padding: "0" }}
        >
          {vehicles
            .sort((a, b) => {
              if (a.enroll_code === "spare" && b.enroll_code !== "spare") return 1
              if (a.enroll_code !== "spare" && b.enroll_code === "spare") return -1
              return 0
            })
            .map((vehicle, index) => (
              <div key={index} className={"un-enroll-card-div"}>
                <span className="card-item-title">
                  {t("common:cardEndingIn")} <strong>{vehicle?.name_of_vehicle?.slice(-4)}</strong>
                  <br />
                  {vehicle?.name_of_vehicle?.slice(0, -5)}
                  <br />
                </span>
                {vehicle.enroll_code === "spare" && (
                  <span className={"spare-card"}>{t("common:spareCard")}</span>
                )}
                <span
                  className={"dashboard-link-color-black"}
                  onClick={() => setCurrentCard(vehicle)}
                >
                  {t("common:assignVehicle")}
                </span>
              </div>
            ))}
        </Card.Content>
        <Link to={navigationPaths.vehicleIndex()}>
          <Container textAlign="center" className="margin-bottom-15-top-10">
            <span className={"dashboard-link-color-red"}>{t("seeAllUnassignedVehicles")}</span>
          </Container>
        </Link>
        <span />
      </Card>
      <AddVehicleModal card={currentCard} setCard={setCurrentCard} loadUnenrolledVehicles={true} />
    </React.Fragment>
  )
}

export default UnenrolledVehicles
